import React from 'react';
import { Link } from '@mui/material';
import LogInComponent from '../features/logon/logon';
import ResetPasswordComponent from '../features/logon/resetPasswordComponent';
import MDBox from './MDBox';
import MDButton from 'components/MDButton';

export function LoginForgotPassword(props) {
  const [isForgotPassword, setIsForgotPassword] = React.useState(false);

  const toggle = () => {
    setIsForgotPassword(!isForgotPassword);
  };

  return (
    <MDBox>
      {!isForgotPassword ? (
        <LogInComponent onSuccess={props.onSuccess} enableNavigation={props?.enableNavigation ?? false} />
      ) : (
        <div />
      )}
      {isForgotPassword ? <ResetPasswordComponent /> : <div />}
      {isForgotPassword ? (
        <MDButton
          variant="text"
          sx={{ fontSize: '13px', textTransform: 'none', fontWeight: 700, color: (theme) => theme.palette.info.main }}
          onClick={toggle}
        >
          {'< Powrót do logowania'}
        </MDButton>
      ) : (
        <div />
      )}
    </MDBox>
  );
}
